export const ACTION_KEYS = {
  DASHBOARD_VIEW: "dashboard:view",
  BILLING_VIEW: "billing:view",
  BILLING_RUN: "billing:run",
  CAPTURE_RATE_VIEW: "capture-rate:view",
  BUDGETING_VIEW: "budgeting:view",
  CASH_FLOW_VIEW: "cash-flow:view",
  FORECASTING_VIEW: "forecasting:view",
  CUSTOMER_VIEW: "customer:view",
  CUSTOMER_EDIT: "customer:edit",
  REGION_MANAGE: "region:manage",
  TEAM_MANAGE: "team:manage",
  SETTINGS_MANAGE: "settings:manage",
  INTEGRATION_QBO: "integration:qbo",
  INTEGRATION_GENESYS: "integration:genesys",
  ACCESS_MANAGE: "system:manage-access",
  TEAM_MEMBER_MANAGE: "team-member:manage",
  TEAM_MEMBER_PAY: "team-member:pay",
  EMAIL_REPORT_SEND: "email-report:send",
  TRANSCRIPT_VIEW: "transcript:view",
  PCC_PERFORMANCE_VIEW: "pcc-performance:view",
  HIRING_NEEDS_VIEW: "hiring-needs:view",
  CLOCK_SELF: "clock:self",
  CLOCK_MANAGE: "clock:manage",
  TIMESHEET_TL_REVIEW: "timesheet-review:team-lead",
  TIMESHEET_OM_REVIEW: "timesheet-review:om",
  AI_PLATFORM_VIEW: "ai-platform:view",
  PAYROLL_VIEW: "payroll:view",
  SCHEDULE_MANAGE: "schedule:manage",
  SCHEDULE_VIEW: "schedule:view",
} as const;

export type ActionKey = (typeof ACTION_KEYS)[keyof typeof ACTION_KEYS];
